import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LayoutStack } from 'design-system/server';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations, useLocale } from 'next-intl';
import styles from './PublicFace.module.css';
import { RailsRoutes } from '@/helpers/utils';
import type { Locale } from '@/i18n/types';
function getUserProfileUrl(locale: Locale, id: string) {
  return `${RailsRoutes.userProfile({
    locale,
    id
  })}`;
}
export type PublicFaceProps = {
  id: string;
  name: string;
  image: string;
  isSponsored?: boolean;
};
function PublicFaceName(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className={styles.name}>{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// TODO: alt text needs to be clarified
function CorporatePublicFace(t0) {
  const $ = _c(3);
  const {
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles.sponsorLogo, styles.image);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== image) {
    t2 = <div className={styles.imageWrapper}><Image alt="" src={image} className={t1} objectFit="cover" fill={true} priority={true} /></div>;
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function PrivatePublicFace(t0) {
  const $ = _c(3);
  const {
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles.privateImage, styles.image);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== image) {
    t2 = <Image alt="" src={image} className={t1} width={113} height={113} />;
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function PublicFaceImage(t0) {
  const $ = _c(3);
  const {
    isSponsored,
    image
  } = t0;
  let t1;
  if ($[0] !== image || $[1] !== isSponsored) {
    t1 = isSponsored ? <CorporatePublicFace image={image} /> : <PrivatePublicFace image={image} />;
    $[0] = image;
    $[1] = isSponsored;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function PublicFace(t0) {
  const $ = _c(21);
  const {
    isSponsored: t1,
    name,
    image,
    id
  } = t0;
  const isSponsored = t1 === undefined ? false : t1;
  const t = useTranslations("nextjs.receiver_pages");
  const locale = useLocale();
  let t2;
  if ($[0] !== id || $[1] !== locale) {
    t2 = getUserProfileUrl(locale, id);
    $[0] = id;
    $[1] = locale;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t) {
    t3 = t("public_face_profile_link", {
      publicFace: name
    });
    $[3] = name;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== image || $[7] !== isSponsored) {
    t4 = <PublicFaceImage isSponsored={isSponsored} image={image} />;
    $[6] = image;
    $[7] = isSponsored;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Link href={t2} className={styles.link} aria-label={t3} prefetch={false}>{t4}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== name || $[14] !== t) {
    t6 = t("fundraising_event.display_name", {
      displayName: name
    });
    $[13] = name;
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <PublicFaceName>{t6}</PublicFaceName>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <LayoutStack className={styles.container} space="300" as="section">{t5}{t7}</LayoutStack>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export default PublicFace;